<template>
  <div>
    <div
      class="monri-borrow-tips"
      @click="
        goRouter(`${process.env.VUE_APP_DOMAIN}/content/payment_agreement.html`)
      "
    >
      {{ i18n.borrow_tips }}
    </div>
    <div class="monri-pay-icon">
      <img
        src="@/assets/monri/icon_mastercard.png"
        alt=""
        @click="goRouter('https://www.mastercard.com')"
      />
      <img
        src="@/assets/monri/icon_maestro.png"
        alt=""
        @click="
          goRouter(
            'https://brand.mastercard.com/brandcenter/more-about-our-brands.html'
          )
        "
      />
      <img
        src="@/assets/monri/icon_visv.png"
        alt=""
        @click="goRouter('https://www.visaeurope.com')"
      />
      <img
        src="@/assets/monri/icon_idcheck.png"
        alt=""
        @click="goRouter('https://www.mastercard.com')"
      />
      <img
        src="@/assets/monri/icon_secure.png"
        alt=""
        @click="goRouter('https://www.visaeurope.com')"
      />
      <img
        src="@/assets/monri/icon_monri.png"
        alt=""
        @click="goRouter('http://monri.com/')"
      />
    </div>
    <div class="monri-info-card">
      <div class="monri-info-list">
        <div class="monri-info-row">
          <img src="@/assets/monri/icon_company.png" alt="" />
          <span>{{ i18n.company_name }}</span>
        </div>
        <div class="monri-info-row">
          <img src="@/assets/monri/icon_address3.png" alt="" />
          <span>{{ i18n.company_address }}</span>
        </div>
      </div>
      <div class="monri-info-list">
        <div class="monri-info-row">
          <img src="@/assets/monri/icon_phone2.png" alt="" />
          <span>{{ i18n.company_phone }}</span>
        </div>
        <div class="monri-info-row">
          <img src="@/assets/monri/icon_email.png" alt="" />
          <span>{{ i18n.company_email }}</span>
        </div>
        <div class="monri-info-row">
          <img src="@/assets/monri/icon_id.png" alt="" />
          <span>{{ i18n.company_id }}</span>
        </div>
        <div class="monri-info-row">
          <img src="@/assets/monri/icon_tax.png" alt="" />
          <span>{{ i18n.company_vat }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    i18n() {
      return this.$t("payment");
    }
  },
  data() {
    return {};
  },
  methods: {
    goRouter(path) {
      window.open(path);
    }
  }
};
</script>

<style lang="less" scoped>
.monri-borrow-tips {
  font-size: 28px;
  color: #8b8b8b;
  padding: 30px 40px;
  text-align: center;
}
.monri-pay-icon {
  display: flex;
  justify-content: center;
  img {
    display: block;
    height: 46px;
    margin: 0 14px;
  }
}
.monri-info-card {
  display: flex;
  padding: 30px 20px;
  .monri-info-list {
    flex: 1;
    .monri-info-row {
      display: flex;
      color: #8b8b8b;
      font-size: 22px;
      align-items: center;
      padding: 10px 0;
      img {
        width: 28px;
        height: 28px;
        display: block;
        margin: 0 14px;
      }
    }
  }
}
</style>
